import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nexts/pw-master-front/app/[locale]/dynamic-head-tags.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleScriptLoader"] */ "/home/nexts/pw-master-front/app/[locale]/google-script-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nexts/pw-master-front/app/[locale]/gtm-page-view-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/home/nexts/pw-master-front/app/[locale]/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nexts/pw-master-front/app/[locale]/registry.tsx");
;
import(/* webpackMode: "eager" */ "/home/nexts/pw-master-front/app/global.css");
;
import(/* webpackMode: "eager" */ "/home/nexts/pw-master-front/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/home/nexts/pw-master-front/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/home/nexts/pw-master-front/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/home/nexts/pw-master-front/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nexts/pw-master-front/src/features/data-managment/model/confirm-Initializer.tsx");
